<template>
    <transition name="fade">
        <div class="flex-column ai-center jc-center hp-10">
            <img v-if="!isSuccessScreen" class="w-5" :src="pathImage" />
            <h2>{{ title }}</h2>
            <div
                class="description fs-3 gray-60 m-0 mb-3 flex-column ai-center"
                v-html="description"
            ></div>
            <a v-if="!isSuccessScreen" href="https://go.sellsy.com/" class="btn btn-primary mt-5">{{
                $l10n.__('Retourner sur le site')
            }}</a>
            <!-- Loader -->
            <div v-else class="prelative wp-10 mt-5"><preloader :display="true" /></div>
        </div>
    </transition>
</template>

<script>
import StepperMixin from 'mixins/StepperMixins';
import OnboardingTrialApi from 'api/onboarding/trial/onboardingTrial.js';
import Preloader from 'vcomponents/utilities/Preloader.vue';

const namespace = 'onboardingTrial';

export default {
    name: 'OnboardingTrialFinal',
    components: {
        Preloader,
    },
    mixins: [StepperMixin],
    props: {
        response: {
            type: Object,
            required: true,
            default: null,
        },
        title: {
            type: String,
            required: true,
            default: '',
        },
        description: {
            type: String,
            required: true,
            default: '',
        },
    },
    data() {
        return {
            pathImage: '/ressources/public/img/onboarding/Sellsy_produit_onboarding3.png',
            isActiveAccountTimer: null,
            failureCount: 0,
            namespaceLocalStorage: namespace,
        };
    },
    computed: {
        isSuccessScreen() {
            return this.response.status === 'success';
        },
    },
    created() {
        this.resetSession();
        if (this.isSuccessScreen) {
            this.checkIsActiveAccount();
        }
    },
    beforeUnmount() {
        clearInterval(this.isActiveAccountTimer);
    },
    methods: {
        checkIsActiveAccount() {
            const MAX_CONSECUTIVE_FAILURES = 30;

            this.isActiveAccountTimer = setInterval(() => {
                OnboardingTrialApi.isActiveAccount()
                    .then(({ status }) => {
                        this.failureCount = 0;

                        if (status === 'success') {
                            clearInterval(this.isActiveAccountTimer);
                            window.location.replace(
                                this.response.redirectPath + '?onboarding=true',
                            );
                        }
                    })
                    .catch((err) => {
                        // Session expired server-side: stop polling.
                        if (err?.response?.status === 422) {
                            clearInterval(this.isActiveAccountTimer);
                            return;
                        }

                        this.failureCount += 1;
                        if (this.failureCount >= MAX_CONSECUTIVE_FAILURES) {
                            clearInterval(this.isActiveAccountTimer);
                            this.$router.push({ name: 'onboarding.quicktrial.signup' });
                        }
                    });
            }, 1000);
        },
        /**
         * Delete info session relative to onboarding trial
         */
        resetSession() {
            this.destroyStateInLocalStorage();
            this.destroyStepperInLocalStorage();
            this.destroyLangInLocalStorage();
        },
    },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.description {
    line-height: normal;
}
</style>
